import { useState } from 'react'
import WODetailsSubModal from '../../sub-modals/WODetailsSubModal'
import styles from './styles.module.css'
import SecondaryButton from '../../../../../../global/components/buttons/secondary-button/SecondaryButton'
export interface ITrOrderNumbersProps {
  trOrderNum: string
  addTrOrderNum: string
}

interface IOrderActionsProps {
  openOrderModal: (modalName: string) => void
  closeOrderModal: () => void
  modalName: string
}

export default function OrderActions({
  openOrderModal,
  closeOrderModal,
  modalName,
}: IOrderActionsProps) {

  //WODetailsSubModal
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  const handleClosed = () => {
    setModalOpen(false)
    closeOrderModal()
  }
  


  return (
    <div className={styles.orderActionsContainer}>
      <div className={styles.additionalActions}>
        <WODetailsSubModal
          isOpen={modalOpen}
          handleClosed={handleClosed}
          actionName={modalName}
        />
        <SecondaryButton
          onClick={() => openOrderModal('Customer Information')}
          buttonName='Edit Order'
        />
        {/* <button
          className={styles.button}
          onClick={() => openOrderModal('Customer Information')}>
          Edit Order
        </button>
        <button
          className={styles.button}
          onClick={() => openOrderModal('Appointment Slot')}>
          Reschedule
        </button> */}
      </div>
    </div>
  )
}
